import styled from 'styled-components';

export default styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: ${(props) => props.theme['color.text.body']};

  & > * {
    margin-left: 10px;
  }
`;
